class ServiceAgreementService {
  constructor({ axios }) {
    this.axios = axios;
    this.url = '/api/document/service-agreements';
  }

  async getList({ query = '', dates = [] } = {}) {
    const result = await this.axios.get(this.url, {
      params: {
        query,
        ...(Object.keys(dates).length > 0 && dates),
      },
    });
    const { data } = result;
    return data;
  }

  async getOne({ id }) {
    const { data } = await this.axios.get(`${this.url}/${id}`);
    return data;
  }

  async create({ serviceAgreement }) {
    const { data } = await this.axios.post(this.url, serviceAgreement);
    return data;
  }

  async upload({ id, formData }) {
    const { data } = await this.axios.put(`${this.url}/upload/${id}`, formData);
    return data;
  }

  async update({ serviceAgreement }) {
    const { data } = await this.axios.put(this.url, serviceAgreement);
    return data;
  }

  async archive({ serviceAgreement }) {
    const { _id: id } = serviceAgreement;
    const { data } = await this.axios.delete(`${this.url}/archive/${id}`, { data: serviceAgreement });
    return data;
  }
}

export default ServiceAgreementService;
